/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MeetingType {
    Teams = 0,
    Jitsi = 1,
    None = 2,
}
